import { createTheme } from '@mui/material/styles';
import { baseThemeOptions } from './base-theme-options';
import './type';

export const theme = createTheme(baseThemeOptions);
